export default __webpack_public_path__ + "static/media/header.module.bbf5ff0b.less";